export default __webpack_public_path__ + "static/waxtosilver-e6e60254604eb9add012d26e0ce728e3.png";